<div fxLayout="row" fxLayoutAlign="start center">
    <div>New version available. Load New Version?</div>
    <button mat-button (click)=sendYes()>Yes ({{timer$ | async}})</button>
</div>
